import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import {
  MantineReactTable,
  MRT_ShowHideColumnsButton,
  useMantineReactTable,
} from 'mantine-react-table'
import { getLocalization } from '@/widgets/LanguageSelect/lib/consts'
import { useDefaultManagerTable } from '../../lib/use-default-manager-table'

interface IDefaultManagerTableProps {
  addButtonSlot: ReactNode
}

export const DefaultManagerTable: FC<IDefaultManagerTableProps> = props => {
  const { addButtonSlot } = props
  const {
    defaultManagerData,
    columns,
    isErrorDefaultManager,
    isLoadingDefaultManager,
    columnVisibility,
    setColumnVisibility,
  } = useDefaultManagerTable()
  const { i18n } = useTranslation()
  const localization = getLocalization(i18n.language)

  const table = useMantineReactTable({
    columns,
    data: defaultManagerData,
    enableStickyHeader: false,
    manualPagination: true,
    manualSorting: true,
    enablePagination: false,
    enableColumnActions: false,
    enableSorting: false,
    rowCount: 1,
    localization,
    onColumnVisibilityChange: setColumnVisibility,
    renderTopToolbar: ({ table }) => {
      return (
        <div className='flex flex-row items-center justify-end mb-2'>
          <div className='flex flex-row items-center space-x-2'>
            <MRT_ShowHideColumnsButton className='h-[2.5rem] w-[2.5rem] rounded-md' table={table} />
            {addButtonSlot}
          </div>
        </div>
      )
    },
    mantineToolbarAlertBannerProps: isErrorDefaultManager
      ? {
          color: 'red',
          children: 'Error loading data',
        }
      : undefined,
    mantinePaperProps: {
      shadow: 'none',
      withBorder: false,
    },
    mantineTableProps: {
      sx: {
        tableLayout: 'auto',
      },
    },
    mantineTableBodyProps: {
      sx: {
        '&: td': {
          minWidth: 90,
        },
        '& tr:hover': {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    mantineTableBodyRowProps: {
      className: 'hover:bg-[#F4FAFD]/10',
    },
    state: {
      isLoading: isLoadingDefaultManager,
      showAlertBanner: isErrorDefaultManager,
      showProgressBars: isLoadingDefaultManager,
      columnVisibility,
    },
  })

  return <MantineReactTable table={table} />
}
